export class IdeasReadsPostRequest {
  ideaId: string
  constructor(ideaId: string) { this.ideaId = ideaId }
}
